import { render, staticRenderFns } from "./RoutingDetailsVan.vue?vue&type=template&id=fdd6036a"
import script from "./RoutingDetailsVan.vue?vue&type=script&lang=js"
export * from "./RoutingDetailsVan.vue?vue&type=script&lang=js"
import style0 from "./RoutingDetailsVan.vue?vue&type=style&index=0&id=fdd6036a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports